<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>人员管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- <el-row>
			<el-col :span="8" :offset="9" class="biankuang">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>用户基本信息</span>
						<el-button @click="dialogFormVisible = true" style="float: right; padding: 3px 0" type="text">编辑</el-button>

						<el-dialog title="个人信息修改" :visible.sync="dialogFormVisible">
							<el-form :model="editForm">
								<el-form-item label="姓名" :label-width="formLabelWidth">
									<el-input v-model="editForm.name" style="width: 350px"></el-input>
								</el-form-item>
								<el-form-item label="密码" :label-width="formLabelWidth">
									<el-input type="password" v-model="editForm.password" placeholder="请输入密码" style="width: 350px"></el-input>
								</el-form-item>
							</el-form>
							<div slot="footer" class="dialog-footer">
								<el-button @click="dialogFormVisible = false">取 消</el-button>
								<el-button type="primary" @click="dialogFormVisible = false">保 存</el-button>
							</div>
						</el-dialog>
					</div>
					<el-row class="item">
						<el-col :span="8" class="title">姓名：</el-col>
						<el-col :span="16">{{ data.name }}</el-col>
					</el-row>
					<el-row class="item">
						<el-col :span="8" class="title">ID：</el-col>
						<el-col :span="16">{{ data.id }}</el-col>
					</el-row>
					<el-row class="item">
						<el-col :span="8" class="title">用户角色：</el-col>
						<el-col :span="16">{{ data.role }}</el-col>
					</el-row>
					<el-row class="item">
						<el-col :span="8" class="title">工作部门：</el-col>
						<el-col :span="16">{{ data.department }}</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
		<div></div> -->


		<div class="biankuang">
			<el-row type="flex" align="middle">
				<el-col :span="12">
					<div class="nav-box">
						<div>
							<i class="el-icon-setting"></i>
						</div>
						<router-link :to="{name: 'SystemUserPwd'}">密码修改</router-link>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="nav-box">
						<div>
							<i class="el-icon-user"></i>
						</div>
						<router-link :to="{name: 'SystemUserManage'}">用户管理</router-link>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="nav-box">
						<div>
							<i class="el-icon-thumb"></i>
						</div>
						<router-link :to="{name: 'SystemRoleManage'}">角色管理</router-link>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: {
					name: '我是谁',
					id: 'abc123',
					role: '工厂级系统管理员',
					department: 'xxxx工厂001车间',
				},
				dialogFormVisible: false,
				formLabelWidth: '120px',
				editForm: {
					name: '我是谁',
					password: '',
				},
			}
		},
	}
</script>

<style scoped>
	/*导航*/
	.nav-box {
		width: 180px;
		height: 120px;
		margin: 0 auto;
		padding-top: 40px;
		border: 1px #eee solid;
		background-color: #fafafa;
		text-align: center;
	}

	.nav-box i {
		font-size: 48px;
		margin-bottom: 20px;
	}

	/*卡片*/
	.box-card {
		width: 400px;
	}

	.item {
		margin-bottom: 18px;
	}
	.clearfix {
		font-size: larger;
		font-weight: bold;
	}

	.biankuang {
		margin-top: 90px;
	}

	.title {
		text-align: right;
		font-weight: bold;
	}
</style>
